import { z } from 'zod'
import { PointStatus } from '@library/enums'
import { dateValueSchema } from './date-value'

/** 點數里程明細明細資料 Schema */
export const pointHistoryDetailSchema = z.object({
  /** 方案 id */
  id: z.string(),
  /** 方案名稱[英文] */
  englishName: z.string(),
  /** 方案名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 方案名稱[繁體中文] */
  traditionalName: z.string(),
  /** 券號 */
  couponNo: z.string().nullable()
})

/** 點數歷程 Schema */
export const pointHistorySchema = z.object({
  /** 建立日期 */
  createTime: dateValueSchema,
  /** 狀態 */
  status: z.nativeEnum(PointStatus),
  /** 明細 */
  detail: pointHistoryDetailSchema,
  /** 點數 */
  point: z.number()
})

/** 企業點數 Schema */
export const pointHistoryListDataSchema = z.object({
  /** 點數編號 */
  pointNo: z.string(),
  /** 到期日 */
  expireDate: dateValueSchema,
  /** 可使用點數 */
  point: z.number(),
  /** 點數歷程 */
  pointHistory: z.array(pointHistorySchema)
})

/** 點數歷程 */
export interface PointHistoryListData
  extends z.infer<typeof pointHistoryListDataSchema> {}

export interface PointHistory extends z.infer<typeof pointHistorySchema> {}
